import { ContactDTO } from "./ContactDTO";
import { SupportContactDTO } from "./SupportContactDTO";

export class SubscriptionContactsDTO {
    main: ContactDTO;
    financial: ContactDTO;
    supports: SupportContactDTO[];

    constructor(obj?) {
        obj = obj || {};

        this.main = new ContactDTO(obj.main);
        this.financial = new ContactDTO(obj.financial);
        this.supports = obj.supports || [];
    }
}
